import { RequestStatus } from 'typed/api';
import { ActionType, Action } from 'typed/actions';
import { IReducer, networkActionReducer } from './';
import { Entity, IEntityReducerState, isPaginationSlice, isNetworkArray, isSimpleArray, IEntityReducerCreator } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

const entityDeleteAllReducer: IEntityReducerCreator = <E extends Entity, T extends ActionType>(def: IEntityReducerState<E>, type: T): IReducer<any, Action<T>> => {
    const nr = networkActionReducer<T, E>(type);
    return function entityDeleteAllReducer(state: IEntityReducerState<E> | undefined = deepClone(def), action: Action<T>): IEntityReducerState<E> {
        if (action.type === type) {
            let data = isNetworkArray(state) ? state.Data : isSimpleArray(state) ? state : [state];

            data = action.payload.status !== RequestStatus.SUCCEEDED ?
                deepAssign(data, data.map(item => action.payload.entityIDs.includes(item.ID) ? nr(item, action) : item)) :
                deepAssign(data, data.filter(item => !action.payload.entityIDs.includes(item.ID)));

            if (action.payload.status === RequestStatus.SUCCEEDED && isPaginationSlice(state)) {
                state = deepAssign(state, {
                    Count: state.Count - action.payload.entityIDs.length,
                    TotalCount: state.Count - action.payload.entityIDs.length,
                })
            }

            return isNetworkArray(state) ? deepAssign(state, { Data: data }) : isSimpleArray(state) ? data : data[0];
        }
        return state;
    };
}

export default entityDeleteAllReducer;